import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { Observable, filter, map } from 'rxjs';
import { PAGES_WITHOUT_HEADER } from 'src/app/core/constants/pages-without-header';

import { AdminAlert } from '../../interfaces/admin-alert';
import { AdminAlertsService } from '../../services/admin-alerts.service';
import { AdminAlertComponent } from '../admin-alert/admin-alert.component';

const PAGES_WITH_ADMIN_ALERTS = [
  '/contracts/contracts-page/my-contracts',
  '/contracts/contracts-page/my-templates',
  '/projects',
  '/certificates-of-insurance/dashboard',
  '/certificates-of-insurance/certificates-page/projects',
  '/certificates-of-insurance/certificates-page/certificates',
  '/certificates-of-insurance/subcontractors',
  '/certificates-of-insurance/reports',
  '/subcontractor-insurance',
  '/subcontractor-insurance/discover',
  '/lending',
  '/invoicing/payments/send',
  '/invoicing/payments/pending',
  '/invoicing/payments/history',
  '/messages',
  '/user/profile',
  '/user/users-and-roles',
  '/user/notification-settings',
  '/user/billing',
  '/invoicing/accounts-payable',
  '/invoicing/dashboard',
  '/invoicing/invoices',
  '/invoicing/payment-history',
  '/contacts/contacts-page/contacts',
  '/dashboard',
  '/homepage',
];

@Component({
  selector: 'app-admin-alerts-container',
  templateUrl: './admin-alerts-container.component.html',
  styleUrls: ['./admin-alerts-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AdminAlertComponent, AsyncPipe],
})
export class AdminAlertsContainerComponent implements OnInit {
  private adminAlertsService = inject(AdminAlertsService);
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);

  readonly alerts$: Observable<AdminAlert[]>;
  visible$: Observable<boolean>;

  constructor() {
    this.alerts$ = this.adminAlertsService.getItems();
  }

  ngOnInit(): void {
    this.visible$ = this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(
        () =>
          !PAGES_WITHOUT_HEADER.some((page) => this.router.url.startsWith(page)) &&
          PAGES_WITH_ADMIN_ALERTS.some((page) => this.router.url.startsWith(page)),
      ),
      takeUntilDestroyed(this.destroyRef),
    );

    this.adminAlertsService.startPulling().pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
  }

  onDismiss(alertId: string): void {
    this.adminAlertsService.hideAlert(alertId);
  }
}
